import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
// Assuming FAQ_DATA is structured as an array of {question, answer} objects.
// If not, it can be easily mapped from the separate arrays.
import { faqData } from "./FAQ_DATA";
import "./faq.css";

// variant="accordion" (default) — the collapsible list used on /my-account/faqs.
// variant="cards"     — static cards matching the landing page's user-story and
//                       Ways of Looking cards.
const FAQ = ({ variant = "accordion" }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (variant === "cards") {
    return (
      <div className="faq-container faq-container--cards">
        <div className="faq-cards">
          {faqData.map((item, index) => (
            <article key={index} className="faq-card">
              <div className="faq-card-num">
                {String(index + 1).padStart(2, "0")}
              </div>
              <h3 className="faq-card-question">{item.question}</h3>
              <p className="faq-card-answer">{item.answer}</p>
            </article>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="faq-container">
      <div className="faq-list">
        {faqData.map((item, index) => {
          const isOpen = activeIndex === index;
          return (
            <div
              key={index}
              className={`faq-item ${isOpen ? "open" : ""}`}
              // The faq-item acts as a "tile"
            >
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                <span>{item.question}</span>
                <FontAwesomeIcon
                  icon={isOpen ? faChevronUp : faChevronDown}
                  className="faq-icon"
                />
              </button>
              {/* The conditional rendering is replaced by a CSS height transition */}
              <div className="faq-answer-wrapper">
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQ;
